(function () {
  var sections = document.querySelectorAll('[data-acquisition-offer]');
  if (!sections.length) return;

  var fittedShipStatuses = new WeakSet();

  sections.forEach(function (section) {
    initGalleryCarousel(section);
    initShipStatus(section);
    initTimer(section);
    initPackSelector(section);
  });

  function initGalleryCarousel(section) {
    var gallery = section.querySelector('[data-offer-gallery]');
    if (!gallery || !window.FlowSwipeCarousel) return;

    window.FlowSwipeCarousel.init({
      gallery: gallery,
      track: gallery.querySelector('[data-offer-gallery-track]'),
      slides: gallery.querySelectorAll('[data-offer-gallery-slide]'),
      pagination: gallery.querySelector('[data-offer-gallery-pagination]'),
      pageClassName: 'acquisition-offer__gallery-page',
      pageLabelPrefix: 'View image ',
    });
  }

  function initShipStatus(section) {
    var status = section.querySelector('[data-acquisition-ship-status]');
    if (!status) return;

    var text = status.querySelector('[data-acquisition-ship-status-text]');
    if (!text) return;

    var offsetDays = toNumber(status.dataset.shipDateOffsetDays || '7');
    var preorderDate = new Date();
    preorderDate.setDate(preorderDate.getDate() + offsetDays);

    text.textContent = 'Order in next 2 hours for ' + formatMonthDay(preorderDate) + ' pre-order.';
    initShipStatusFit(status, text);
  }

  function initShipStatusFit(status, text) {
    if (fittedShipStatuses.has(status)) return;

    fittedShipStatuses.add(status);
    var resizeFrame = null;

    function fit() {
      resizeFrame = null;
      fitOneLineText(text);
    }

    function requestFit() {
      if (resizeFrame) return;
      resizeFrame = window.requestAnimationFrame(fit);
    }

    requestFit();
    window.addEventListener('resize', requestFit);
    window.addEventListener('load', requestFit);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(requestFit).catch(function () {
        // Font loading can fail without affecting the fallback fit.
      });
    }

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(requestFit);
      observer.observe(status);
      observer.observe(text);
    }
  }

  function fitOneLineText(text) {
    if (!text) return;

    var computed = window.getComputedStyle(text);
    var baseFontSize = Number.parseFloat(text.dataset.baseFontSize || computed.fontSize);
    var minFontSize = 8;

    if (!Number.isFinite(baseFontSize) || baseFontSize <= 0) return;

    text.dataset.baseFontSize = String(baseFontSize);
    text.style.fontSize = baseFontSize + 'px';

    if (!text.clientWidth || text.scrollWidth <= text.clientWidth) return;

    var nextSize = Math.max(minFontSize, baseFontSize * (text.clientWidth / text.scrollWidth));
    text.style.fontSize = nextSize.toFixed(2) + 'px';

    while (text.scrollWidth > text.clientWidth && nextSize > minFontSize) {
      nextSize = Math.max(minFontSize, nextSize - 0.5);
      text.style.fontSize = nextSize.toFixed(2) + 'px';
    }
  }

  function formatMonthDay(date) {
    var months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    var day = date.getDate();

    return months[date.getMonth()] + ' ' + day + getOrdinalSuffix(day);
  }

  function getOrdinalSuffix(day) {
    var teenRemainder = day % 100;
    if (teenRemainder >= 11 && teenRemainder <= 13) return 'th';

    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  function initTimer(section) {
    var timer = section.querySelector('[data-acquisition-timer]');
    if (!timer) return;

    var duration =
      (toNumber(section.dataset.timerHours) * 60 * 60) +
      (toNumber(section.dataset.timerMinutes) * 60) +
      toNumber(section.dataset.timerSeconds);

    if (duration <= 0) return;

    var sectionId = section.dataset.sectionId || 'default';
    var storageKey = 'flow_acquisition_offer_timer_' + sectionId;
    var endTime = readStoredEndTime(storageKey);
    var now = Date.now();

    if (!endTime || endTime <= now) {
      endTime = now + duration * 1000;
      try {
        window.localStorage.setItem(storageKey, String(endTime));
      } catch (error) {
        endTime = now + duration * 1000;
      }
    }

    var hoursEl = timer.querySelector('[data-timer-hours]');
    var minutesEl = timer.querySelector('[data-timer-minutes]');
    var secondsEl = timer.querySelector('[data-timer-seconds]');

    function tick() {
      var remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));

      if (remaining <= 0) {
        endTime = Date.now() + duration * 1000;
        try {
          window.localStorage.setItem(storageKey, String(endTime));
        } catch (error) {
          // Timer can still run without storage.
        }
        remaining = duration;
      }

      var hours = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;

      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function initPackSelector(section) {
    var sectionId = section.dataset.sectionId || '';
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-offer-pack-card]'));
    var inputs = cards
      .map(function (card) {
        return card.querySelector('.acquisition-offer__pack-input');
      })
      .filter(Boolean);

    if (!inputs.length) return;

    var bundleInput = inputs.find(function (input) {
      return input.value === '2';
    });
    var singleDeselect = section.querySelector('[data-offer-single-deselect]');
    var bundleGifts = section.querySelector('[data-offer-bundle-gifts]');
    var variantInput = section.querySelector('[data-offer-variant-input]');
    var quantityInput = section.querySelector('[data-offer-quantity-input]');
    var salePrice = section.querySelector('[data-offer-sale-price]');
    var comparePrice = section.querySelector('[data-offer-compare-price]');
    var submitButton = section.querySelector('[data-offer-buy-wrap] .acquisition-offer__buy-button');
    var stickySubmitButton = section.querySelector('[data-offer-sticky-submit]');
    var stickySalePrice = section.querySelector('[data-offer-sticky-sale-price]');
    var stickyComparePrice = section.querySelector('[data-offer-sticky-compare-price]');

    function syncSelection(input) {
      inputs.forEach(function (candidate) {
        candidate.checked = candidate === input;
      });

      cards.forEach(function (card) {
        var cardInput = card.querySelector('.acquisition-offer__pack-input');
        var isActive = cardInput === input;
        var expanded = card.querySelector('.acquisition-offer__pack-expanded');

        card.classList.toggle('is-active', isActive);
        if (expanded) {
          expanded.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        }
      });

      if (bundleGifts) {
        var giftsAvailable = input.value === '2';
        bundleGifts.classList.toggle('is-visible', giftsAvailable);
        bundleGifts.classList.toggle('is-muted', !giftsAvailable);
        bundleGifts.setAttribute('aria-hidden', 'false');
        bundleGifts.setAttribute('aria-disabled', giftsAvailable ? 'false' : 'true');
        if (giftsAvailable) {
          bundleGifts.removeAttribute('role');
          bundleGifts.removeAttribute('tabindex');
          bundleGifts.removeAttribute('aria-label');
        } else {
          bundleGifts.setAttribute('role', 'button');
          bundleGifts.setAttribute('tabindex', '0');
          bundleGifts.setAttribute('aria-label', 'Select 2 docks to unlock these gifts');
        }
      }

      if (variantInput) {
        variantInput.value = input.dataset.variantId || '';
        variantInput.disabled = input.dataset.available === 'false';
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (quantityInput) {
        quantityInput.value = input.dataset.quantity || '1';
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (salePrice) {
        salePrice.textContent = input.dataset.price || '';
      }

      if (stickySalePrice) {
        stickySalePrice.textContent = input.dataset.price || '';
      }

      if (comparePrice) {
        comparePrice.textContent = input.dataset.compare || '';
        comparePrice.hidden = input.dataset.hasCompare !== 'true';
      }

      if (stickyComparePrice) {
        stickyComparePrice.textContent = input.dataset.compare || '';
        stickyComparePrice.hidden = input.dataset.hasCompare !== 'true';
      }

      syncDiscountCopy(input);

      if (submitButton) {
        submitButton.disabled = input.dataset.available === 'false';
      }

      if (stickySubmitButton) {
        stickySubmitButton.disabled = input.dataset.available === 'false';
      }

      document.dispatchEvent(
        new CustomEvent('flow:dock-selection-changed', {
          detail: {
            sectionId: String(sectionId),
            variantId: input.dataset.variantId || null,
            dockQuantity: input.dataset.quantity || '1',
          },
        })
      );
    }

    function selectPack(input) {
      if (!input) return;

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function selectBundleFromDismiss(event) {
      event.preventDefault();
      event.stopPropagation();

      window.setTimeout(function () {
        selectPack(bundleInput);
      }, 0);
    }

    function selectBundleFromMutedGifts(event) {
      if (!bundleGifts || !bundleInput || !bundleGifts.classList.contains('is-muted')) return;

      event.preventDefault();
      event.stopPropagation();
      selectPack(bundleInput);
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) syncSelection(input);
      });
    });

    cards.forEach(function (card) {
      var input = card.querySelector('.acquisition-offer__pack-input');
      if (!input) return;

      card.addEventListener('click', function (event) {
        if (event.target.closest('[data-offer-single-deselect]')) return;

        event.preventDefault();
        selectPack(input);
      });
    });

    if (singleDeselect && bundleInput) {
      singleDeselect.addEventListener('click', selectBundleFromDismiss);
      singleDeselect.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        selectBundleFromDismiss(event);
      });
    }

    if (bundleGifts && bundleInput) {
      bundleGifts.addEventListener('click', selectBundleFromMutedGifts);
      bundleGifts.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        selectBundleFromMutedGifts(event);
      });
    }

    var checked = inputs.find(function (input) {
      return input.checked;
    }) || inputs[0];

    if (checked) {
      checked.checked = true;
      syncSelection(checked);
    }

    initStickyBuy(section);
  }

  function syncDiscountCopy(input) {
    var section = input.closest('[data-acquisition-offer]');
    if (!section) return;

    var discountPercent = input.dataset.discountPercent || '';
    var discountLabel = discountPercent ? discountPercent + '%' : '';
    var dockCountLabel = formatDockCount(input.dataset.dockCount || input.value);

    section.querySelectorAll('[data-offer-discount-copy]').forEach(function (element) {
      var template = element.dataset.offerDiscountTemplate || element.textContent || '';
      var text = discountLabel ? applyOfferDiscountTemplate(template, discountLabel, dockCountLabel) : template;

      element.textContent = text;
    });
  }

  function applyOfferDiscountTemplate(template, discountLabel, dockCountLabel) {
    var text = template || '';

    text = text.replace(/\d+(?:\.\d+)?%/g, discountLabel);
    if (dockCountLabel) {
      text = text.replace(/x\s*\d+\s*Docks?/gi, dockCountLabel);
    }

    return text;
  }

  function formatDockCount(value) {
    var dockCount = Number.parseInt(value, 10);
    if (!Number.isFinite(dockCount) || dockCount <= 0) return '';

    return 'x' + dockCount + ' ' + (dockCount === 1 ? 'Dock' : 'Docks');
  }

  function initStickyBuy(section) {
    var stickyBuy = section.querySelector('[data-offer-sticky-buy]');
    var inlineBuy = section.querySelector('[data-offer-buy-wrap]');
    if (!stickyBuy || !inlineBuy) return;

    var stickySubmit = stickyBuy.querySelector('[data-offer-sticky-submit]');
    var scrollFrame = null;

    function updateStickyBuy() {
      scrollFrame = null;

      var inlineRect = inlineBuy.getBoundingClientRect();
      var viewportHeight = (window.visualViewport && window.visualViewport.height) || window.innerHeight || document.documentElement.clientHeight;
      var shouldShow = inlineRect.top > viewportHeight;

      stickyBuy.classList.toggle('is-hidden', !shouldShow);
      stickyBuy.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (stickySubmit) {
        stickySubmit.tabIndex = shouldShow ? 0 : -1;
      }
    }

    function requestStickyUpdate() {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(updateStickyBuy);
    }

    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate);
    updateStickyBuy();
  }

  function readStoredEndTime(storageKey) {
    try {
      return Number(window.localStorage.getItem(storageKey));
    } catch (error) {
      return null;
    }
  }

  function toNumber(value) {
    var number = Number.parseInt(value, 10);
    return Number.isFinite(number) ? number : 0;
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }
})();
